import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Holidays } from '../../../components/Holidays/Holidays';
import { Page } from '../../../components/Page/Page';
import { SchoolYearTable } from '../../../components/SchoolYear/SchoolYearTable';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SetupSchoolYears = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <TabBar
        variant={'large'}
        tabs={[
          {
            trigger: t('schoolYear.title', { count: 2 }),
            id: 'schoolYear',
            content: <SchoolYearTable key={'schoolYear'} />,
          },
          {
            trigger: t('holidays.title', { count: 2 }),
            id: 'holidays',
            content: <Holidays key={'holidays'} />,
          },
        ]}
      />
    </Page>
  );
};
